/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
const emailWrapper = document.querySelector('#wholesale-contact-form #ContactFormEmail')?.closest('.o-layout__item');
const phoneWrapper = document.querySelector('#wholesale-contact-form input[name="contact[Phone Number]"]')?.closest('.o-layout__item');
if (emailWrapper && phoneWrapper) {
// Move Email field before Phone Number field
phoneWrapper.parentNode.insertBefore(emailWrapper, phoneWrapper);
}
const phoneElement = document.querySelector('.footer__content [aria-label="Call"]');
  if (phoneElement) {
    let phone = phoneElement.innerText.trim();

    if (/^\d{10}$/.test(phone)) {
      const formatted = phone.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
      phoneElement.innerText = formatted;
    }
  }

  (function () {
  function initQtyTotals(scope) {
    var root = scope || document;

    var totalSpans = root.querySelectorAll('.qty-line__total-value[data-unit-price]');
    if (!totalSpans.length) return;

    totalSpans.forEach(function (totalSpan) {
      var qtyLine = totalSpan.closest('.qty-line');
      if (!qtyLine) return;

      var qtyInput = qtyLine.querySelector('input[name="quantity"]');
      if (!qtyInput) return;

      function formatMoney(cents) {
        var fmt = totalSpan.getAttribute('data-money-format') ||
                  (window.Shopify && Shopify.money_format) ||
                  '${{amount}}';

        if (window.Shopify && typeof Shopify.formatMoney === 'function') {
          return Shopify.formatMoney(cents, fmt);
        }
        var amount = (cents / 100).toFixed(2);
        return fmt.replace('{{amount}}', amount).replace('{{ amount }}', amount);
      }

      function getUnitPriceCents() {
        var v = totalSpan.getAttribute('data-unit-price');
        var n = parseInt(v, 10);
        return Number.isFinite(n) ? n : 0;
      }

      function getQty() {
        var q = parseInt(qtyInput.value, 10);
        return Number.isFinite(q) && q > 0 ? q : 1;
      }

      function updateTotal() {
        var unit = getUnitPriceCents();
        var qty = getQty();
        var total = unit * qty;
        totalSpan.textContent = formatMoney(total);
      }
      updateTotal();
      qtyInput.addEventListener('input', updateTotal);
      qtyInput.addEventListener('change', updateTotal);
      var mo = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          if (mutations[i].type === 'attributes' && mutations[i].attributeName === 'data-unit-price') {
            updateTotal();
            break;
          }
        }
      });
      mo.observe(totalSpan, { attributes: true });
      qtyLine.addEventListener('click', function (e) {
        var btn = e.target.closest('button[minus], button[plus]');
        if (!btn) return;
        setTimeout(updateTotal, 0);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initQtyTotals(document);
  });
  document.addEventListener('shopify:section:load', function (e) {
    initQtyTotals(e.target);
  });
})();
(function () {
  function getLabelsEl() {
    return (
      document.querySelector('.product-single__label_items') ||
      document.querySelector('.product-single__label__items')
    );
  }

  function moveLabels() {
    if (!document.body.classList.contains('template-product')) return;

    var isMobile = window.matchMedia('(max-width: 979px)').matches;
    var target = document.querySelector('[data-mobile-labels]');
    var labels = getLabelsEl();

    if (!target || !labels) return;

    if (!labels.__origParent) {
      labels.__origParent = labels.parentNode;
      labels.__origNext = labels.nextSibling;
    }

    if (isMobile) {
      if (labels.parentNode !== target) target.appendChild(labels);
    } else {

      if (labels.__origParent && labels.parentNode !== labels.__origParent) {
        if (labels.__origNext) labels.__origParent.insertBefore(labels, labels.__origNext);
        else labels.__origParent.appendChild(labels);
      }
    }
  }

  document.addEventListener('DOMContentLoaded', moveLabels);

  var mq = window.matchMedia('(max-width: 979px)');
  if (mq.addEventListener) mq.addEventListener('change', moveLabels);
  else mq.addListener(moveLabels);
})();

(() => {
  if (!document.body.classList.contains('template-product')) return;
  const MQ = window.matchMedia('(max-width: 989px)');
  const ACTIVATE_BEFORE_DISAPPEAR_PX = 600;
  const HYSTERESIS_PX = 8;
  let ticking = false;
  let cta = null;
  let atcBtn = null;
  const show = () => cta && cta.classList.add('is-visible');
  const hide = () => cta && cta.classList.remove('is-visible');
  const findAtcButton = () => {
    return (
      document.querySelector('form[action^="/cart/add"] button[type="submit"]') ||
      document.querySelector('button[name="add"]') ||
      document.querySelector('product-form button[type="submit"]') ||
      document.querySelector('.product-form button[type="submit"]') ||
      null
    );
  };

  const getProductTopTarget = (btn) => {
  
    return (
      btn.closest('.js-section__product-single') ||
      btn.closest('section[id^="shopify-section-"]') ||
      btn.closest('section') ||
      document.querySelector('main') ||
      document.body
    );
  };

  const update = () => {
    ticking = false;

    if (!cta) cta = document.querySelector('.pdp-mobile-shop-cta');
    if (!cta) return;

    if (!MQ.matches) {
      hide();
      return;
    }

    if (!atcBtn || !document.contains(atcBtn)) {
      atcBtn = findAtcButton();

      if (atcBtn) {
        const productTop = getProductTopTarget(atcBtn);

        cta.onclick = () => {
          const y = productTop.getBoundingClientRect().top + window.scrollY;
          hide();
          window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
        };
      }
    }

    if (!atcBtn) {
      hide();
      return;
    }

    const rect = atcBtn.getBoundingClientRect();
    const shouldShow = rect.bottom <= ACTIVATE_BEFORE_DISAPPEAR_PX;
    const shouldHide = rect.bottom > (ACTIVATE_BEFORE_DISAPPEAR_PX + HYSTERESIS_PX);

    if (shouldShow) show();
    else if (shouldHide) hide();
  };

  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  };

  const init = () => {
    cta = document.querySelector('.pdp-mobile-shop-cta');
    if (!cta) return;

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    MQ.addEventListener?.('change', onScroll);

    update();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();



